import { type GooglePlace } from "types/quote-types";
import { getGooglePlacesDetails } from "../get-details";

export async function getGooglePlacesDestinationDetails(place: GooglePlace) {
  return {
    ...(await getGooglePlacesDetails({
      fields: ["address_components", "formatted_address", "place_id"],
      placeId: place.googleId,
    })),
    terms: place.terms,
  };
}
